<template>
  <ul class="lst_sitemap">
    <li class="col_group" v-for="(map, mapIdx) in filterSiteMap" :key="mapIdx" :class="{ is_col_merge2: map.isMerged }">
      <template v-for="(menu, menuIdx) in map.menus" v-if="isShow(menu)">
        <em :key="`gnb_footer_menu_em_${menu.msgTitleId}`" class="title_txt is_pc_show">
          <span v-if="!menu.externalUrl">{{ $t(menu.msgTitleId) }}</span>
          <a v-else :href="menu.externalUrl" :target="menu.target">{{ $t(menu.msgTitleId) }}</a>
        </em>
        <a :key="`gnb_footer_menu_a_${menu.msgTitleId}`" class="title_txt is_m_show"
          @click="showCollapse[mapIdx][menuIdx] = !showCollapse[mapIdx][menuIdx]"
          :class="showCollapse[mapIdx][menuIdx] ? 'collapsed' : null" :aria-controls="`gnb_footer_menu_${menu.msgTitleId}`"
          :aria-expanded="showCollapse[mapIdx][menuIdx] ? 'true' : 'false'">
          {{ $t(menu.msgTitleId) }}
        </a>

        <b-collapse v-if="!map.isMerged" :key="`gnb_footer_menu_${menu.msgTitleId}`" tag="ul" :id="`gnb_footer_menu_${menu.msgTitleId}`"
            v-model="showCollapse[mapIdx][menuIdx]" class="lst_sitemap_detail" :style="{ display: isMobile ? 'none' : '' }">
          <li class="link_item" v-for="(link, linkIdx) in menu.links" :key="linkIdx" v-if="isShow(link)">
            <a v-if="!!link.externalUrl" :href="`${link.externalUrl}`" class="link_txt" :target="`${link.target}`">
              {{ link.useMsgId ? $t(link.msgNameId) : link.name }}
            </a>
            <a :href="link.url" v-else-if="canUseRoute" @click="!!link.externalUrl? routerProxy(link.externalUrl, $event):routerProxy(link.url, $event)" class="link_txt">
              {{ link.useMsgId ? $t(link.msgNameId) : link.name }}
            </a>
            <a v-else :href="`${getDomain('homepage')}${link.url}`" class="link_txt">
              {{ link.useMsgId ? $t(link.msgNameId) : link.name }}
            </a>
          </li>
        </b-collapse>

        <b-collapse v-else :key="`gnb_footer_menu_${menu.msgTitleId}`" tag="ul" :id="`gnb_footer_menu_${menu.msgTitleId}`"
          v-model="showCollapse[mapIdx][menuIdx]" class="lst_sitemap_detail" :style="{ display: isMobile ? 'none' : '' }">
          <ul class="col_group" v-for="(links, linksIdx) in menu.links" :key="linksIdx">
            <li class="link_item" v-for="(link, linkIdx) in links" :key="linkIdx"
              v-if="!link.showOnlyMobile || (link.showOnlyMobile && isMobile)">
              <router-link-ex v-if="canUseRoute" :to="link.url" class="link_txt">{{ link.useMsgId ? $t(link.msgNameId) : link.name }}
              </router-link-ex>
              <a v-else :href="`${getDomain('homepage')}${link.url}`" class="link_txt">{{ link.useMsgId ? $t(link.msgNameId) : link.name }}</a>
            </li>
          </ul>
        </b-collapse>
      </template>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { from } from 'rxjs'
import { map } from 'rxjs/operators'
import 'bootstrap/js/dist/collapse'
import { BCollapse } from 'bootstrap-vue'
import ConsoleAppDownloadCommon from './ConsoleAppDownload.mixin'
import { namespace, types } from '../../store/modules/common-store'

const SiteMapData = require(`${envs.common.footer.sitemap}`).default

function checkItemShowByEnvironment(item, isMobile) {
  if (item.display === undefined) {
    return true
  } else if (item.display === 'PC') {
    return !isMobile
  } else if (item.display === 'MOBILE') {
    return isMobile
  }
}

function checkItemShowByCountry(item, isJp) {
  if (item.hide === undefined) {
    return true
  } else if (item.hide === 'JP') {
    return !isJp
  } else if (item.hide === 'KR') {
    return isJp
  }
}

export default {
  mixins: [ConsoleAppDownloadCommon, SiteMapData],
  data() {
    return {
      showCollapse: {},
      showAppDownload: envs.common.footer.app_download.enabled
    }
  },
  created() {
    this.initCollaspe()
  },
  watch: {
    $route: function() {
      this.initCollaspe()
    }
  },
  methods: {
    routerProxy(linkUrl, event) {
      event.preventDefault()
      const [url, hash] = linkUrl.split('#')
      if (this.$route.path === url && hash && this.$route.hash === `#${hash}`) {
        const targetEl = document.querySelector(`#${hash}`)
        if (targetEl) {
          targetEl.scrollIntoView()
        }
      } else {
        this.$router.push(linkUrl)
      }
    },
    initCollaspe() {
      from(this.siteMap)
        .pipe(
          map((site, index) => {
            let subShowCollapse = {}
            from(site.menus)
              .pipe(map((menu, menuIdx) => this.$set(subShowCollapse, menuIdx, false)))
              .subscribe(() => this.$set(this.showCollapse, index, subShowCollapse))
          })
        )
        .subscribe()
    },
    isShow(item) {
      return checkItemShowByEnvironment(item, this.isMobile) && checkItemShowByCountry(item, this.isJp)
    }
  },
  computed: {
    ...mapState(namespace, ['isMobile']),
    documentPath() {
      return this.isJp ? '/ja/TOAST/ja/Overview/' : '/ko/TOAST/ko/Overview/'
    },
    filterSiteMap() {
      return this.siteMap.filter(f => this.isShow(f))
    }
  },
  components: { BCollapse }
}
</script>
